import utils from '@/mixins/utils.js'
import { getQuantidadeTratamentosAtraumaticos } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado.
 * @param {Boolean} exibirSemTra Indica se o filtro Sem TRA está ativo.
 * @returns {Object}
 */
export function getDataFields(mes = null, exibirSemTra = false) {
  const colunaQuantidade = exibirSemTra ? 'Outros' : 'Atraumáticos'

  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeTratamentosAtraumaticos(item, mes, exibirSemTra)
      },
    },
  }
}

export const infoHtml = ``
